import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderOutlookCalendarCommon = {
  key: 'outlookCalendar',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'outlookCalendar',
    authUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/authorize`,
    tokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
    scopes: [
      'https://graph.microsoft.com/Calendars.ReadWrite',
      'https://graph.microsoft.com/User.Read',
      'https://graph.microsoft.com/MailboxSettings.Read',
      'offline_access',
    ],
  }),
}

export type ProviderOutlookCalendarAccountType = {
  lastMessageDate?: string
  email?: string
}
